import { io } from "socket.io-client";

// Single shared Socket.IO connection to the auction engine (auction-service).
//
// Origin resolution:
//   * REACT_APP_AUCTION_URL if set (explicit override);
//   * in CRA dev (localhost:3000) the engine runs on :5600 — cookies are
//     host-scoped (not port-scoped), so the session cookie set via the :5500 API
//     is still sent cross-port, and the engine's CORS allows localhost:3000;
//   * otherwise same origin, where nginx routes /socket.io to the engine.
function auctionOrigin() {
    if (process.env.REACT_APP_AUCTION_URL) return process.env.REACT_APP_AUCTION_URL;
    if (typeof window !== "undefined") {
        const { hostname, port, protocol } = window.location;
        if ((hostname === "localhost" || hostname === "127.0.0.1") && port === "3000") {
            return `${protocol}//${hostname}:5600`;
        }
    }
    return ""; // same origin
}

let socket = null;

/** Lazily create (and reuse) the authenticated socket. */
export function getSocket() {
    if (socket) return socket;
    socket = io(auctionOrigin(), {
        path: "/socket.io",
        withCredentials: true,        // send the shared session cookie
        transports: ["websocket"],
        autoConnect: true,
        reconnection: true,
    });
    return socket;
}

export function disconnectSocket() {
    if (socket) {
        socket.removeAllListeners();
        socket.disconnect();
        socket = null;
    }
}

// Promise wrapper around an emit with an ack, so pages can `await` a bid.
export function emitAck(event, payload, timeoutMs = 7000) {
    return new Promise((resolve) => {
        const s = getSocket();
        let done = false;
        const finish = (v) => { if (!done) { done = true; resolve(v); } };
        try {
            s.emit(event, payload, (ack) => finish(ack));
        } catch (e) {
            finish({ ok: false, reason: "socket_error" });
        }
        setTimeout(() => finish({ ok: false, reason: "timeout" }), timeoutMs);
    });
}

export default getSocket;
